import StoreBase from './_base'
import SearchConditions from '../service/_searchConditions'
import FormService from '../service/_form'
import ConfigForm from '../service/_config'
import DepartureCode from '../const/data-departure-code'
import { dateFormat, dayJs } from '../../functions/index'

import FormStore from './_form-store'
import UiStore from '../../store/_ui-store'
import tourCode from '../const/tour_result.json'
import Collection from '../../service/_collection'

/**
 * TopStore // 検索一覧ページのデータを格納するstore
 *
 * @extends {StoreBase}
 */
class TopStore extends StoreBase {
  constructor() {
    super()
    this.store = {}

    const selectedStayDaysOptions = [{ key: 'travel_days', value: String(FormStore.getData('stayDays', 'none')) }]
    let filteredStayDaysItems = new Collection(tourCode)

    // 選択されたオプションのみでフィルタリング
    selectedStayDaysOptions.forEach(option => {
      if (option.value !== 'none') {
        filteredStayDaysItems = filteredStayDaysItems.filter(item => item[option.key] === option.value)
      }
    })
    const array4 = new Collection(filteredStayDaysItems.get())
      .map(item => {
        return item.travel_days
      })
      .unshift({ key: 'none', value: '旅行日数を選択' })
      .get()
    const filterStayDaysUnique = [...new Map(array4.map(itemObject => [itemObject, itemObject])).values()]

    this.form = {
      departureCode: {
        value: 'none',
        type: 'select',
        format: 'text',
        list: SearchConditions.departureCodeList(),
        update: () => {
          // this.areaCodeList()
        },
        validation: (name, value, form) => this.checkDepartureCode(name, value, form),
      },
      departureDate: {
        value: dayJs().format('YYYY-MM-DD'),
        type: 'calendar',
        format: 'text',
      },
      //   rooms: {
      //     value: '大人2名',
      //     type: 'select',
      //     format: 'text',
      //   },
      stayDays: {
        value: 'none',
        type: 'select',
        format: 'number',
        list: SearchConditions.stayDaysList(filterStayDaysUnique),
        validation: (name, value, form) => this.checkStayDays(name, value, form),
      },
      areaCode: {
        value: 'none',
        type: 'select',
        format: 'text',
        list: SearchConditions.areaCodeList(),
        // update: () => this.countryCodeList(),
        validation: (name, value, form) => this.checkArrivalCode(name, value, form),
      },
      countryCode: {
        value: 'none',
        type: 'select',
        format: 'text',
        list: SearchConditions.areaCodeToSelectData('none'),
        // update: () => this.cityCodeList(),
        validation: (name, value, form) => this.checkCountryCode(name, value, form),
      },
      cityCode: {
        value: 'none',
        type: 'select',
        format: 'text',
        list: SearchConditions.countryCodeToSelectData('none'),
        // update: () => this.stayDaysList(),
        validation: (name, value, form) => this.checkCityCode(name, value, form),
      },
    }
  }

  /**
   * init // 変数の動的な初期化
   */
  init() {
    FormStore.init(this.form)
  }

  updateDropdown() {
    console.log('Dropdown変更')
    const cityCode = UiStore.getData('cityCode', 'none')
    const areaCode = UiStore.getData('areaCode', 'none')
    const departureCode = UiStore.getData('departureCode', 'none')
    console.log('Dropdown変更:cityCode', cityCode)
    console.log('Dropdown変更:areaCode', areaCode)
    console.log('Dropdown変更:departureCode', departureCode)
  }

  /**
   * areaCodeList // 方面コードリストの選択肢を変更
   */
  areaCodeList() {
    console.log('出発地変更')
    const cityCode = FormStore.getData('cityCode', 'none')
    const areaCode = FormStore.getData('areaCode', 'none')
    const departureCode = FormStore.getData('departureCode', 'none')
    // UiStore.updateData('cityCode', cityCode)
    // UiStore.updateData('areaCode', areaCode)
    // UiStore.updateData('departureCode', departureCode)
    const filterList = UiStore.getData('filterList')
    console.log('出発地変更:cityCode', cityCode)
    console.log('出発地変更:departureCode', departureCode)
    console.log('出発地変更:filterList', filterList)

    // const filterAreaList = SearchConditions.departureCodeToSelectData(departureCode)
    // FormStore.updateList('areaCode', filterAreaList)
    // // FormStore.updateData('areaCode', 'none')
    // console.log('出発地変更:filterAreaList', filterAreaList)

    const tourArray = new Collection(tourCode)
    const array = tourArray
      // .filter(item => item.departure_city_code === departureCode || item.airport_code === departureCode)
      .filter(item => item.airport_code === departureCode)
      .sort(false, 'display')
      .map(item => {
        return item
      })
      .get()
    // const array2 = new Collection(array)
    //   .map(item => {
    //     return { key: item.area_code, value: item.area_name }
    //   })
    //   //   .unshift({ key: 'none', value: '方面を選択' })
    //   .get()

    // const filterAreaUnique = [...new Map(array2.map(itemObject => [itemObject.key, itemObject])).values()]
    const travelDaysObject = [...new Set(array.map(item => item.travel_days))].sort()
    console.log('filterAreaUnique', travelDaysObject)

    FormStore.updateList('stayDays', SearchConditions.stayDaysList(travelDaysObject))
    // FormStore.updateData('cityCode', 'none')

    // FormStore.updateList('areaCode', originalList)
    // UiStore.updateData('filterList', array)
    array.map(item => {
      // console.log('出発地変更:エリア変更させる?', item)
      // console.log('出発地変更:エリア変更させる?', cityCode)
    })
    // if (
    //   departureCode === 'none' ||
    //   filterAreaList.some(
    //     item => item.airport_code === departureCode && item.city_code === cityCode && item.disable !== true,
    //   )
    // ) {
    //   console.log('出発地変更:エリア変更させない')
    // } else {
    //   console.log('出発地変更:エリア変更させる')
    //   FormStore.updateData('areaCode', 'none')
    //   $('.dropdown')
    //     .find('[data-name=' + 'areaCode' + '].dropdown-toggle')
    //     .html('方面を選択')
    //   $('.dropdown')
    //     .find('[data-name=' + 'countryCode' + '].dropdown-toggle')
    //     .html('国・地域を選択')
    //   $('.dropdown')
    //     .find('[data-name=' + 'cityCode' + '].dropdown-toggle')
    //     .html('都市を選択')
    // }
    this.trigger(`formSelect:areaCode`)
    this.trigger(`FormUl`)
  }

  /**
   * countryCodeList // 国コードリストの選択肢を変更
   */
  countryCodeList() {
    // console.log('国コードリスト')
    const areaCode = FormStore.getData('areaCode', 'none')
    const filterList = UiStore.getData('filterList')
    const stayDaysBefore = FormStore.getData('stayDays', 'none')

    const tourArray = new Collection(filterList)
    const array = tourArray
      .filter(item => item.area_code === areaCode)
      .sort(false, 'display')
      .map(item => {
        return item
      })
      .get()
    const array2 = new Collection(array)
      .map(item => {
        return { key: item.country_code, value: item.country_name }
      })
      .unshift({ key: 'none', value: '都市を選択' })
      .get()

    const filterAreaUnique = [...new Map(array2.map(itemObject => [itemObject.key, itemObject])).values()]
    FormStore.updateList('countryCode', SearchConditions.areaCodeToSelectData(areaCode, filterAreaUnique))
    FormStore.updateData('countryCode', 'none')

    const travelDaysObject = [...new Set(array.map(item => item.travel_days))].sort()
    if (travelDaysObject.length > 0) {
      FormStore.updateList('stayDays', SearchConditions.stayDaysList(travelDaysObject))
      if (travelDaysObject.some(item => parseInt(item) === stayDaysBefore)) {
        console.log('stayDaysBefore:Boolean', true)
        FormStore.updateData('stayDays', stayDaysBefore)
      } else {
        console.log('stayDaysBefore:Boolean', false)
        FormStore.updateData('stayDays', 'none')
        $('.dropdown')
          .find('[data-name=' + 'stayDays' + '].dropdown-toggle')
          .html('旅行日数を選択')
      }
    }
    this.trigger(`formSelect:countryCode`)
    this.trigger(`FormUl`)
  }

  /**
   * cityCodeList. // 都市コードリストの選択肢を変更
   */
  cityCodeList() {
    // console.log('都市コードリスト')
    const countryCode = FormStore.getData('countryCode', 'none')
    const stayDaysBefore = FormStore.getData('stayDays', 'none')
    const filterList = UiStore.getData('filterList')

    const tourArray = new Collection(filterList)
    const array = tourArray
      .filter(item => item.country_code === countryCode)
      .sort(false, 'display')
      .map(item => {
        return item
      })
      .get()
    const array2 = new Collection(array)
      .map(item => {
        return { key: item.city_code, value: item.city_name }
      })
      .unshift({ key: 'none', value: '都市を選択' })
      .get()
    const filterAreaUnique = [...new Map(array2.map(itemObject => [itemObject.key, itemObject])).values()]

    FormStore.updateList('cityCode', SearchConditions.countryCodeToSelectData(countryCode, filterAreaUnique))
    FormStore.updateData('cityCode', 'none')

    const travelDaysObject = [...new Set(array.map(item => item.travel_days))].sort()
    if (travelDaysObject.length > 0) {
      FormStore.updateList('stayDays', SearchConditions.stayDaysList(travelDaysObject))
      if (travelDaysObject.some(item => parseInt(item) === stayDaysBefore)) {
        console.log('stayDaysBefore:Boolean', true)
        FormStore.updateData('stayDays', stayDaysBefore)
      } else {
        console.log('stayDaysBefore:Boolean', false)
        FormStore.updateData('stayDays', 'none')
        $('.dropdown')
          .find('[data-name=' + 'stayDays' + '].dropdown-toggle')
          .html('旅行日数を選択')
      }
    }

    this.trigger(`formSelect:cityCode`)
    this.trigger(`FormUl`)
  }

  /**
   * stayDaysList. // 旅行日数リストの選択肢を変更
   */
  stayDaysList() {
    // console.log('都市コードリスト')
    const cityCode = FormStore.getData('cityCode', 'none')
    const stayDaysBefore = FormStore.getData('stayDays', 'none')
    const filterList = UiStore.getData('filterList')

    const tourArray = new Collection(filterList)
    const array = tourArray
      .filter(item => item.city_code === cityCode)
      .sort(false, 'display')
      .map(item => {
        return item
      })
      .get()
    // const array2 = new Collection(array)
    //   .map(item => {
    //     return { key: item.city_code, value: item.city_name }
    //   })
    //   .unshift({ key: 'none', value: '都市を選択' })
    //   .get()
    // const filterAreaUnique = [...new Map(array2.map(itemObject => [itemObject.key, itemObject])).values()]

    // FormStore.updateList('cityCode', SearchConditions.countryCodeToSelectData(countryCode, filterAreaUnique))
    // FormStore.updateData('cityCode', 'none')
    console.log('stayDaysList:cityCode', cityCode)
    console.log('stayDaysList:filterList', filterList)
    console.log('stayDaysList:stayDaysList', array)
    const travelDaysObject = [...new Set(array.map(item => item.travel_days))].sort()
    if (travelDaysObject.length > 0) {
      console.log('stayDaysBefore', stayDaysBefore)
      console.log('stayDaysBefore', travelDaysObject)
      FormStore.updateList('stayDays', SearchConditions.stayDaysList(travelDaysObject))
      if (travelDaysObject.some(item => parseInt(item) === stayDaysBefore)) {
        console.log('stayDaysBefore:Boolean', true)
        FormStore.updateData('stayDays', stayDaysBefore)
      } else {
        console.log('stayDaysBefore:Boolean', false)
        FormStore.updateData('stayDays', 'none')
        $('.dropdown')
          .find('[data-name=' + 'stayDays' + '].dropdown-toggle')
          .html('旅行日数を選択')
      }
    }

    this.trigger(`formSelect`)
    this.trigger(`FormUl`)
  }

  dataArrivalCode() {
    const cityCode = FormStore.getData('cityCode', null)
    const countryCode = FormStore.getData('countryCode', null)
    const areaCode = FormStore.getData('areaCode', null)
    if (cityCode && cityCode !== 'none') return cityCode
    if (countryCode && countryCode !== 'none') return countryCode
    if (areaCode) return areaCode
    return null
  }

  dataCountryCode() {
    const countryCode = FormStore.getData('countryCode', null)
    if (countryCode && countryCode !== 'none') return countryCode
    return null
  }

  dataCityCode() {
    const cityCode = FormStore.getData('cityCode', null)
    if (cityCode && cityCode !== 'none') return cityCode
    return null
  }

  dataDepartureCode() {
    const departureCode = FormStore.getData('departureCode', null)
    if (departureCode && departureCode !== 'none') return departureCode
    return null
  }

  dataStayDays() {
    const stayDays = FormStore.getData('stayDays', null)
    if (stayDays && stayDays !== 'none') return stayDays
    return null
  }

  checkArrivalCode(name, value, form) {
    const arrivalCode = this.dataArrivalCode()
    if (arrivalCode === 'none') form.errors.arrivalCode = '目的地(方面)を設定してください'
    else form.errors.arrivalCode = null
  }

  checkCountryCode(name, value, form) {
    const countryCode = this.dataCountryCode()
    // console.log('check:countryCode', countryCode)
    if (countryCode === 'none' || countryCode === null) form.errors.countryCode = '目的地(国・地域)を選択してください'
    else form.errors.countryCode = null
  }

  checkCityCode(name, value, form) {
    const cityCode = this.dataCityCode()
    // console.log('check:cityCode', cityCode)
    if (cityCode === 'none' || cityCode === null) form.errors.cityCode = '目的地(都市)を選択してください'
    else form.errors.cityCode = null
  }

  checkDepartureCode(name, value, form) {
    const departureCode = this.dataDepartureCode()
    if (departureCode === null) form.errors.departureCode = '出発地を設定してください'
    else form.errors.departureCode = null
  }

  checkStayDays(name, value, form) {
    const stayDays = this.dataStayDays()
    // console.log('check:cityCode', cityCode)
    if (stayDays === 'none' || stayDays === null) form.errors.stayDays = '旅行日数を選択してください'
    else form.errors.stayDays = null
  }


  /**
   * send // APIでリクエストを送信
   */
  send(url) {
    const arrivalCode = this.dataArrivalCode()
    FormStore.validations()
    if (FormStore.isError()) return this.trigger('Form:errors')
    let departureDate = FormStore.getData('departureDate', null)
    if ($('#NTA_date_undecided-check').prop('checked')) departureDate = null
    FormService.call('get', url, {
      'departure-code': FormStore.getData('departureCode', null),
      'departure-date': departureDate,
      'stay-days': FormStore.getData('stayDays', null),
      'arrival-code': arrivalCode,
    })
  }
}

export default new TopStore()
